import React, { useEffect, useState } from "react";

export default function Cart({ elem }) {
    const cartUrl = elem.dataset.cartUrl || "";
    const [data, setData] = useState({});

    useEffect(() => {
        window.Dibook.cart.fetchCart().then((response) => {
            setData(response.content?.data?.cart || []);
        });

        let addSubId = window.Dibook.cart.on("itemsAdded", (payload) => {
            setData(payload.content?.data?.cart || []);
        });

        let removeSubId = window.Dibook.cart.on("itemsRemoved", (payload) => {
            setData(payload.content?.data?.cart || []);
        });

        $('[data-toggle="tooltip"]').tooltip();

        return () => {
            window.Dibook.cart.off("itemsAdded", addSubId);
            window.Dibook.cart.off("itemsRemoved", removeSubId);
        };
    }, []);

    return (
        <a
            data-toggle="tooltip"
            data-placement="bottom"
            title="Kosár"
            aria-label="Keresés"
            href={cartUrl}
            className="header-cart-button"
            data-content={data.length || false}
        >
            {(typeof data == "object" && data.length > 0) ? 
            <img src="/images/icon/cart-full-black.svg" alt="cart-full" /> :
            <img src="/images/icon/cart-black.svg" alt="cart" />}
        </a>
    );
}
